export default __webpack_public_path__ + "static/media/QK_9979.e2a6d3d3.jpg";